import { Container } from "reactstrap";
import { BackLink, ToastContainer } from "../../components/Common";
import QuoteDetailsPage from "./page";

const QuoteDetailsPageWrapper = () => {
    return (
        <div className="page-content">
            <Container fluid>
                <BackLink />
                <QuoteDetailsPage />
            </Container>
            <ToastContainer />
        </div>
    );
};

export default QuoteDetailsPageWrapper;
